var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"d-block",staticStyle:{"width":"22px"}},[_c('h1',{staticClass:"text-right",staticStyle:{"color":"#afb1b0"}},[_vm._v(_vm._s(_vm.step))])]),_c('span',{staticClass:"step-line ml-3 mr-4"})])
}
var staticRenderFns = []

export { render, staticRenderFns }